import { DtoWhItemList } from './../dominio/DtoWhItemList';
import { WhItemMastServicio } from './../servicio/WhItemMast.service';
import { PrincipalBaseComponent } from 'src/app/util/PrincipalBaseComponent';
import { MaMiscelaneosdetalleServicio } from './../../../core/mamiscelaneosdetalle/service/mamiscelaneosdetalle.service';
import { SelectItem, LazyLoadEvent } from 'primeng/primeng';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { FiltroWhItemMast } from './../dominio/FiltroWhItemMast';
import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NoAuthorizationInterceptor } from '../../../../util/interceptor/NoAuthorizationInterceptor';
import { CoDocumento } from 'src/app/erp/comercial/codocumento/dominio/CoDocumento';
import { CoCotizacion } from 'src/app/erp/comercial/cotizacion/dominio/CoCotizacion';

@Component({
    selector: 'app-item-listado',
    templateUrl: './whItemmast-listado.component.html'
})
export class WhItemMastComponent extends PrincipalBaseComponent implements OnInit {
    origen: string = '';
    tag: string = '';
    acction: string;
    subscribedParam = 'initial value';
    filtro: FiltroWhItemMast = new FiltroWhItemMast();
    seleccionados: DtoWhItemList;
    cargando: Boolean = true;
    lstEstados: SelectItem[] = [];
    codigo: string;
    desc: string;
    verdescuentos: string;
    coCotizacion: CoCotizacion = new CoCotizacion();
    coDocumento: CoDocumento = new CoDocumento();
    CoCotizacion = new CoCotizacion();

    constructor(
        private readonly route: ActivatedRoute,
        private router: Router,
        private maMiscelaneosdetalleServicio: MaMiscelaneosdetalleServicio,
        private cdref: ChangeDetectorRef,
        private whItemMastServicio: WhItemMastServicio,
        noAuthorizationInterceptor: NoAuthorizationInterceptor,
        messageService: MessageService
    ) { super(noAuthorizationInterceptor, messageService); }
    paginacion: any = new Object();
    @ViewChild(Table,{static:false}) dt: Table;

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    ngOnInit(): void {
        this.seleccionados = null;
        this.origen = this.route.snapshot.params['origen'] as string;
        this.subscribedParam = this.route.snapshot.params['almacen'] as string;
        this.acction = this.route.snapshot.params['accion'] as string;
        this.verdescuentos = this.route.snapshot.params['verdescuentos'] as string;

        if (this.origen === 'PEDIDO') {
            this.coDocumento = JSON.parse(this.route.snapshot.params['bean']);
        } else if (this.origen === 'COTIZACION') {
            this.coCotizacion = JSON.parse(this.route.snapshot.params['bean']);
        }

        this.cargarEstados();
        this.filtro.almacen = this.subscribedParam;
    }

    listado() {

    }

    onRowDblclick(event) {
        if (this.origen === 'PEDIDO') {
            this.agregarItemCotizacion();
        } else {
            this.agregarItemSeleccionados();
        }
    }

    defaultBuscar(event?: any) {
        if (event.keyCode === 13) {
            this.buscar();
        }
    }

    cargarEstados() {
        this.bloquearPagina();
        this.lstEstados.push({ label: ' -- Ver Todos -- ', value: null });
        this.maMiscelaneosdetalleServicio.listarPorCabecera('CO', '999999', 'ESTSTOCK').then(
            res => {
                res.forEach(
                    reg => {
                        this.lstEstados.push({ label: reg.descripcionlocal, value: reg.pk.codigoelemento.trim() });
                    }
                );
                this.cargando = false;
                this.desbloquearPagina();
                this.filtro.estado = 'ST';
            }
        );
    }

    cargarPaginacion(event: LazyLoadEvent) {

        if (this.cargando) {
            return;
        }

        this.bloquearPagina();

        this.filtro.paginacion.listaResultado = [];
        this.filtro.paginacion.registroInicio = event.first;
        this.filtro.paginacion.cantidadRegistrosDevolver = event.rows;
        this.whItemMastServicio.listarItemPaginacion(this.filtro)
            .then(res => {
                this.filtro.paginacion = res;
                this.desbloquearPagina();
            });
    }

    buscar() {
        this.cargando = false;
        this.dt.reset();
    }

    agregarItemSeleccionados() {
        if (this.seleccionados === undefined || this.seleccionados === null) {
            this.mostrarMensajeAdvertencia('Seleccionar un Item');
            return;
        }

        if (this.origen === 'PEDIDO') {
            this.router.navigate(['royal/item-detalle', this.origen, this.acction, JSON.stringify(this.seleccionados), JSON.stringify(this.coDocumento), 'N'], { skipLocationChange: true });
        } else {
            this.router.navigate(['royal/item-detalle', this.origen, this.acction, JSON.stringify(this.seleccionados), JSON.stringify(this.coCotizacion), 'N'], { skipLocationChange: true });
        }
    }

    onDoblRowSelect(event: any) {
        this.codigo = '';
        const reg: any = new Object();
        reg.data = event.data;
        reg.tag = this.tag;
        console.log(reg);
        console.log(reg.data.item);
        this.mostrarMensajeExito(reg.data.item);
        console.log(reg);
        console.log(reg.data.item);
        this.codigo = reg.data.item;
        this.desc = reg.data.descripcionLocal;
        this.mostrarMensajeExito(reg.data.item);
    }


    verPedidoActual() {
        this.router.navigate(['royal/pedido-mantenimiento', 'VERITEMS', JSON.stringify(this.coDocumento), this.acction], { skipLocationChange: true });
    }

    verInventario() {
        if (this.seleccionados === null || this.seleccionados === undefined) {
            this.mostrarMensajeAdvertencia('Debe seleccionar un Item');
            return;
        }

        this.codigo = this.seleccionados.item.trim();
        this.desc = this.seleccionados.descripcionLocal.trim();
        if (this.origen === 'PEDIDO') {
            this.router.navigate(['royal/item-inventario', this.origen, this.codigo.trim(), this.desc.trim(), this.filtro.almacen.trim(), JSON.stringify(this.coDocumento), this.acction, this.verdescuentos], { skipLocationChange: true });
        } else {
            this.router.navigate(['royal/item-inventario', this.origen, this.codigo.trim(), this.desc.trim(), this.filtro.almacen.trim(), JSON.stringify(this.coCotizacion), this.acction, this.verdescuentos], { skipLocationChange: true });
        }
    }
    agregarItemCotizacion() {
        this.agregarItemSeleccionados();
    }
    verCotizacionActual() {
        console.log(this.coCotizacion);
        this.router.navigate(['/royal/cocotizacion-mantenimiento', 'VERITEMS', JSON.stringify(this.coCotizacion), this.acction], { skipLocationChange: true });
    }
}
